// Switch das Preferências (liga/desliga), usado pelos blocos que têm um switch
// por módulo (cupom de preparo, senha do pedido).
export default function Chave({ ligado, onAlternar, desabilitado, id }) {
  return (
    <button type="button" onClick={onAlternar} disabled={desabilitado} data-e2e={id}
      role="switch" aria-checked={!!ligado} aria-pressed={!!ligado}
      className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ${ligado ? "bg-primary" : "bg-gray-300 dark:bg-gray-600"} disabled:opacity-50`}>
      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${ligado ? "translate-x-6" : "translate-x-1"}`} />
    </button>
  );
}
